import { getLocale, t } from "../i18n/index.js";

export const $ = <T extends HTMLElement = HTMLElement>(selector: string, root: ParentNode = document): T | null => root.querySelector<T>(selector);
export const $$ = <T extends HTMLElement = HTMLElement>(selector: string, root: ParentNode = document): T[] =>
  Array.from(root.querySelectorAll<T>(selector));

let toastTimer = null;

const INTL_TAGS = { fr: "fr-FR", en: "en-GB" };
const intlTag = () => INTL_TAGS[getLocale()] || INTL_TAGS.fr;

export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function formatDate(value) {
  if (!value) return "";
  return new Intl.DateTimeFormat(intlTag(), {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatNumber(value) {
  if (value === undefined || value === null || value === "") return "-";
  if (typeof value !== "number") return escapeHtml(value);
  return new Intl.NumberFormat(intlTag(), { maximumFractionDigits: 1 }).format(
    value,
  );
}

export function formatBytes(bytes: number) {
  const units = ["B", "kB", "MB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1000 && unit < units.length - 1) {
    value /= 1000;
    unit += 1;
  }
  return `${new Intl.NumberFormat(intlTag(), { maximumFractionDigits: unit ? 1 : 0 }).format(value)} ${units[unit]}`;
}

export function formatValue(value, unit) {
  const rendered = formatNumber(value);
  return `${rendered}${unit ? ` ${escapeHtml(unit)}` : ""}`;
}

export function formatPercent(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return escapeHtml(value ?? "-");
  return `${num > 0 ? "+" : ""}${new Intl.NumberFormat(intlTag(), { maximumFractionDigits: 1 }).format(num)}%`;
}

export function showToast(message) {
  $(".toast")?.remove();
  const toast = document.createElement("div");
  toast.className = "toast";
  toast.textContent = repairText(message);
  document.body.appendChild(toast);
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.remove(), 2400);
}

export function repairText(value) {
  const replacements = [
    ["ÃƒÂ©", "é"],
    ["ÃƒÂ¨", "è"],
    ["ÃƒÂª", "ê"],
    ["ÃƒÂ«", "ë"],
    ["ÃƒÂ ", "à"],
    ["ÃƒÂ¢", "â"],
    ["ÃƒÂ¹", "ù"],
    ["ÃƒÂ»", "û"],
    ["ÃƒÂ®", "î"],
    ["ÃƒÂ¯", "ï"],
    ["ÃƒÂ´", "ô"],
    ["ÃƒÂ¶", "ö"],
    ["ÃƒÂ§", "ç"],
    ["Ãƒâ€°", "É"],
    ["Ãƒâ‚¬", "À"],
    ["Ãƒâ€¡", "Ç"],
    ["Ã‚Â·", "·"],
    ["Ã‚Â°", "°"],
    ["Ã‚ ", " "],
    ["Ã¢â‚¬â„¢", "'"],
    ["Ã¢â‚¬Å“", '"'],
    ["Ã¢â‚¬Â", '"'],
    ["Ã¢â‚¬â€", "—"],
    ["Ã¢â‚¬â€œ", "–"],
    ["Ã¢â‚¬Â¦", "..."],
    ["Ã¢â‚¬Âº", "›"],
    ["Ã¢â€ Â", "←"],
    ["Ã¢â€ â€™", "→"],
    ["Ã¢â€ Â»", "↻"],
    ["Ã¢â€¡Â©", "⇩"],
    ["Ã¢Å¡â„¢", "⚙"],
    ["Ã¢â„¢Â¡", "♡"],
    ["Ã¢Å’Â", "⌁"],
    ["Ã¢Å’Ëœ", "⌘"],
    ["Ã¢—â€¹", "○"],
    ["Ã¢—Å’", "◌"],
    ["Ã¢—Â·", "◷"],
    ["Ã¢â€“Â³", "△"],
    ["Ã¢Å“â€œ", "✓"],
    ["Ã¢â€“Â§", "▧"],
    ["Ã¢â€“Â¤", "▤"],
    ["Ã¢â€“Â£", "▣"],
    ["Ãƒ—", "×"],
    ["Ã¢â€šÂ¬", "€"],
    ["é", "é"],
    ["è", "è"],
    ["Ãª", "ê"],
    ["Ã«", "ë"],
    ["à", "à"],
    ["Ã¢", "â"],
    ["Ã¹", "ù"],
    ["Ã»", "û"],
    ["î", "î"],
    ["Ã¯", "ï"],
    ["ô", "ô"],
    ["Ã¶", "ö"],
    ["Ã§", "ç"],
    ["É", "É"],
    ["Ã€", "À"],
    ["Ã‡", "Ç"],
    ["Â·", "·"],
    ["Â°", "°"],
    ["Â ", " "],
    ["â€™", "'"],
    ["â€œ", '"'],
    ["â€", '"'],
    ["—", "—"],
    ["â€“", "–"],
    ["â€¦", "..."],
    ["â€º", "›"],
    ["â†", "←"],
    ["→", "→"],
    ["↻", "↻"],
    ["â‡©", "⇩"],
    ["âš™", "⚙"],
    ["â™¡", "♡"],
    ["âŒ", "⌁"],
    ["âŒ˜", "⌘"],
    ["â—‹", "○"],
    ["â—Œ", "◌"],
    ["â—·", "◷"],
    ["â–³", "△"],
    ["✓", "✓"],
    ["▧", "▧"],
    ["▤", "▤"],
    ["â–£", "▣"],
    ["â–¦", "▦"],
    ["×", "×"],
    ["â‚¬", "€"],
    ["â™™", "♙"],
  ];
  return replacements.reduce(
    (text, [from, to]) => text.split(from).join(to),
    String(value ?? ""),
  );
}

export function repairDomText(root = document.body) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach((node) => {
    const next = repairText(node.nodeValue || "");
    if (next !== node.nodeValue) node.nodeValue = next;
  });
  root
    .querySelectorAll?.("[aria-label], [title], [alt], [placeholder], [value]")
    .forEach((node) => {
      ["aria-label", "title", "alt", "placeholder", "value"].forEach((attr) => {
        if (!node.hasAttribute(attr)) return;
        const next = repairText(node.getAttribute(attr) || "");
        if (next !== node.getAttribute(attr)) node.setAttribute(attr, next);
      });
    });
}

const BLOCK_STATUSES = [
  "empty",
  "running",
  "escalated",
  "produced",
  "audit_ko",
  "validated",
];

export function statusLabel(status) {
  return t(`blockStatus.${BLOCK_STATUSES.includes(status) ? status : "empty"}`);
}

export function statusSymbol(status) {
  return (
    {
      empty: "○",
      running: "◌",
      escalated: "!",
      produced: "◷",
      audit_ko: "△",
      validated: "✓",
    }[status] || "○"
  );
}

export function initials(name) {
  return String(name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

export function downloadBlob(filename, content, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function excerptText(chunk) {
  if (typeof chunk === "string") return chunk;
  if (chunk && typeof chunk === "object")
    return (
      chunk.text || chunk.content || chunk.excerpt || JSON.stringify(chunk)
    );
  return "";
}
